<template>
    <div class="footer-section">
      <div class="footer-left">
        <p>版权所有 © 2025 百亩林</p>
        <router-link to="/honour" class="license-link">营业执照</router-link>
      </div>
      <div class="footer-right">
        <p>备案号：XYZ123456789</p>
        <!-- <div class="qr-code">
          <img src="@/assets/image/logo.png" alt="二维码" class="qr-image" />
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Footer',
  };
  </script>
  
  <style scoped>
  .footer-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-top: 1px solid #ccc;
    background-color: #ffffff; /* 白色背景 */
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    width: 90%;
    margin: 20px auto;
  }
  
  .footer-left {
    flex: 1;
    text-align: left;
  }
  
  .footer-left p {
    margin: 5px 0;
    font-size: 14px;
  }
  
  .footer-left .license-link {
    color: #4caf50; /* 绿色链接 */
    text-decoration: none;
    font-size: 14px;
  }
  
  .footer-right {
    flex: 1;
    text-align: right;
  }
  
  .footer-right p {
    margin: 5px 0;
    font-size: 14px;
  }
  
  .qr-code {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .qr-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    margin-top: 10px;
  }

  @media screen and (max-width: 768px) {
    .footer-section {
      flex-direction: column;
      padding: 15px;
      width: 95%;
      margin: 15px auto;
    }

    .footer-left, .footer-right {
      width: 100%;
      text-align: center;
      margin: 5px 0;
    }

    .footer-left p, .footer-right p {
      font-size: 12px;
    }

    .footer-left .license-link {
      font-size: 12px;
    }

    .qr-code {
      justify-content: center;
    }

    .qr-image {
      width: 80px;
      height: 80px;
    }
  }

  @media screen and (max-width: 480px) {
    .footer-section {
      padding: 10px;
      width: 98%;
      margin: 10px auto;
    }

    .footer-left p, .footer-right p {
      font-size: 11px;
    }

    .footer-left .license-link {
      font-size: 11px;
    }

    .qr-image {
      width: 60px;
      height: 60px;
    }
  }
  </style>